import React, { useState, useEffect, useRef } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import { Box, Button, Paper } from "@mui/material";
import "./alumni.css";
import ALUMNI1 from "../../../../assests/images/ALUMNI1.jpeg";
import ALUMNI2 from "../../../../assests/images/ALUMNI2.jpeg";
import ALUMNI3 from "../../../../assests/images/ALUMNI3.jpeg";
import ALUMNI4 from "../../../../assests/images/ALUMNI4.jpeg";
import ALUMNI5 from "../../../../assests/images/ALUMNI5.jpeg";
import ALUMNI6 from "../../../../assests/images/ALUMNI66.jpeg";
import ALUMNI7 from "../../../../assests/images/ALUMNI7.jpeg";
import ALUMNI8 from "../../../../assests/images/ALUMNI8.jpeg";
import ALUMNI9 from "../../../../assests/images/ALUMNI9.jpeg";
import ALUMNI10 from "../../../../assests/images/ALUMNI10.jpeg";
import ALUMNI11 from "../../../../assests/images/ALUMNI11.jpeg";
import ALUMNI12 from "../../../../assests/images/ALUMNI2.jpeg";

// Array of alumni images
const images = [
  { src: ALUMNI1, alt: "Alumni 1" },
  { src: ALUMNI2, alt: "Alumni 2" },
  { src: ALUMNI3, alt: "Alumni 3" },
  { src: ALUMNI4, alt: "Alumni 4" },
  { src: ALUMNI5, alt: "Alumni 5" },
  { src: ALUMNI6, alt: "Alumni 6" },
  { src: ALUMNI7, alt: "Alumni 7" },
  { src: ALUMNI8, alt: "Alumni 8" },
  { src: ALUMNI9, alt: "Alumni 9" },
  { src: ALUMNI10, alt: "Alumni 10" },
  { src: ALUMNI11, alt: "Alumni 11" },
  { src: ALUMNI12, alt: "Alumni 12" },
];

const Alumini = () => {
  const [zoomedImage, setZoomedImage] = useState(null);
  const [selectedTab, setSelectedTab] = useState("gallery");
  const zoomModalRef = useRef(null);

  // Handle image click to zoom
  const handleImageClick = (image) => {
    setZoomedImage(image);
  };

  // Close zoomed image
  const closeZoom = () => {
    setZoomedImage(null);
  };

  // Handle MOM tab click to open PDF
  const handleMOMClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/Alumni_minutes_of_meeting.pdf`,
      "_blank"
    );
    setSelectedTab("mom");
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        zoomModalRef.current &&
        !zoomModalRef.current.contains(event.target)
      ) {
        closeZoom();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/Alumni_registration_certificate.pdf`,
      "_blank"
    );
  };

  return (
    <>
      <Header />
      <div className="alumni-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1}
            sx={{
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={selectedTab === "gallery" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("gallery")}
              style={{
                width: "100%",
                color: selectedTab === "gallery" ? "#FFF" : "#000",
                borderColor: selectedTab === "gallery" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
              aria-label="View alumni gallery"
            >
              Gallery
            </Button>
            <Button
              variant={selectedTab === "gallery" ? "contained" : "outlined"}
              onClick={handleClick}
              style={{
                width: "100%",
                color: selectedTab === "gallery" ? "#FFF" : "#000",
                borderColor: selectedTab === "gallery" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
              aria-label="View alumni gallery"
            >
              Alumni Registration Certificate
            </Button>
            <Button
              variant={selectedTab === "mom" ? "contained" : "outlined"}
              onClick={handleMOMClick}
              style={{
                width: "100%",
                color: selectedTab === "mom" ? "#FFF" : "#000",
                borderColor: selectedTab === "mom" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
              aria-label="Open Minutes of Meeting document"
            >
              Minutes of Meeting
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2} className="alumni-content">
            <h2>Alumni</h2>
            <Paper className="image-grid-container">
              <div className="alumni-images">
                {images.map((image, index) => (
                  <div key={index} className="alumni-image-container">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="alumni-image"
                      loading="lazy"
                      onClick={() => handleImageClick(image)}
                    />
                  </div>
                ))}
              </div>
            </Paper>
          </Box>
        </Box>
      </div>
      {zoomedImage && (
        <div className="zoom-modal">
          <div className="zoom-modal-content" ref={zoomModalRef}>
            <button className="zoom-close-button" onClick={closeZoom}>
              ×
            </button>
            <img
              src={zoomedImage.src}
              alt={zoomedImage.alt}
              className="zoom-image"
            />
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Alumini;
